import React, { useMemo } from "react";
import { times } from "ramda";
import { Pager } from "../../components";
import Skeleton from "react-loading-skeleton";
import { v4 as uuidv4 } from "uuid";
// import { tableHeaders } from "./devices-page";

const DevicesTableSkeleton = ({ tenantConfig, line = 1 }) => {
  const skeletonLines = times(
    (i) => (
      <tr key={i}>
        {[...Array(9)].map(() => (
          <td key={uuidv4()}>
            <Skeleton />
          </td>
        ))}
      </tr>
    ),
    line
  );

  const tableHeaders = tenantConfig.devices_headers;

  const columnStyle = useMemo(() => ({ padding: "10px" }), []);

  return (
    !!tenantConfig.slug && (
      <>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr style={{ height: "40px" }}>
                {tableHeaders.map((header, idx) => (
                  <th key={idx}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>{skeletonLines}</tbody>
          </table>
        </div>
        <div className="d-flex justify-content-lg-end pagination-box">
          <Pager />
        </div>
      </>
    )
  );
};

export default DevicesTableSkeleton;
